import React from 'react';
import { connect } from 'react-redux';

const Loader = ({ isLoading }) => {
  return isLoading ? (
    <div className="loaderContainer"><p className="loader"></p></div>
  ) : null;
};

export default connect(state => ({
  isLoading: state.loaderSet.isLoading
}))(Loader);
